import React from "react";
import styled from "styled-components";
import TextEditor from "../../textEditor/textEditor";

interface Props {
    name: string;
    value?: string;
    readOnlyMode?: boolean;
    onEditorChangeHandler: (name: string, rawData: string) => void;
}

const TextEditorInput: React.FC<Props> = ({
    name,
    value,
    readOnlyMode,
    onEditorChangeHandler,
}) => {
    if (!readOnlyMode)
        return (
            <TextEditor
                id={name}
                handleEditorData={(data) => {
                    onEditorChangeHandler(name, data === "<p></p>" ? "" : data);
                }}
                value={value || ""}
            />
        );
    return (
        <HTMLPreview
            dangerouslySetInnerHTML={{
                __html: value || "",
            }}
        />
    );
};

const HTMLPreview = styled.div`
    max-height: 500px;
    max-width: 100%;
    overflow: auto;
`;

export default TextEditorInput;
